import Done from '@mui/icons-material/Done';
import Close from '@mui/icons-material/Close';
import { Box, styled, Typography } from '@mui/material';
import { IPublicAndPrivateSettings } from '@pepperhq/location-sdk';
import { MuiCardForm } from 'lib/form/MuiCardForm';
import { SettingDisplay } from 'lib/SettingDisplay';
import { SwitchFormField } from 'lib/form/fields/SwitchFormField';
import { TextFormField } from 'lib/form/fields/TextFormField';

type IProps = {
    settings: IPublicAndPrivateSettings;
    onSubmit: (values: Record<string, any>) => Promise<boolean>;
};

const PREFIX = 'MarketingSettings';

const classes = {
    settingsCard: `${PREFIX}-settingsCard`,
    displayClassName: `${PREFIX}-displayClassName`
};

const StyledMuiCardForm = styled(MuiCardForm)(({ theme }) => ({
    [`&.${classes.settingsCard}`]: {
        marginBottom: theme.spacing(2),
        overflowY: 'visible' // Needed for the dropdowns
    },
    [`& .${classes.displayClassName}`]: {
        padding: theme.spacing(2)
    }
}));

export function CRMSettingsCard({ settings, onSubmit }: IProps) {
    return (
        <StyledMuiCardForm
            title="Revinate"
            initialValues={{
                revinateIsEnabled: settings?.revinate?.isEnabled ?? false,
                revinateToken: settings?.revinate?.token,
                revinatePointsPerkId: settings?.revinate?.pointsPerkId
            }}
            onSubmit={onSubmit}
            childrenWhileDisplaying={
                <Box display="flex" flexDirection="column">
                    <SettingDisplay label="Revinate Enabled">
                        {settings?.revinate?.isEnabled && <Done />}
                        {!settings?.revinate?.isEnabled && <Close />}
                    </SettingDisplay>
                    <SettingDisplay label="Token">
                        <Typography variant="body2">{settings?.revinate?.token}</Typography>
                    </SettingDisplay>
                    <SettingDisplay label="Points Perk ID">
                        <Typography variant="body2">{settings?.revinate?.pointsPerkId}</Typography>
                    </SettingDisplay>
                </Box>
            }
            childrenWhileEditing={
                <Box display="flex" flexDirection="column">
                    <SettingDisplay label="Revinate Enabled">
                        <SwitchFormField name="revinateIsEnabled" />
                    </SettingDisplay>
                    <SettingDisplay label="Token">
                        <TextFormField name="revinateToken" />
                    </SettingDisplay>
                    <SettingDisplay label="Points Perk ID">
                        <TextFormField name="revinatePointsPerkId" />
                    </SettingDisplay>
                </Box>
            }
            className={classes.settingsCard}
            boxClassName={classes.displayClassName}
        />
    );
}
